import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { AdminBoxContextOperationsResponse } from './admin-box-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBoxStatus } from '../../enums/admin-box-status';
import { AdminBoxSaleReferenceResponse } from './admin-box-sale-reference.response';

@jsonObject
export class AdminBoxCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly price?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly status!: AdminBoxStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminBoxSaleReferenceResponse)
  public readonly boxSale!: AdminBoxSaleReferenceResponse;

  @jsonMember(AdminBoxContextOperationsResponse)
  public readonly contextOperations!: AdminBoxContextOperationsResponse;
}
